import { FC, PropsWithChildren } from "react";
import cn from "classnames";

import styles from './index.module.scss'

type ScreenButtonProps = {
  type?: 'primary' | 'ghost' | 'outlined';
}

export const ScreenButton: FC<PropsWithChildren<ScreenButtonProps>> = ({ children, type = 'primary' }) => {
  return(
    <div className={cn(styles.wrapper, styles[type])}>
      {children}
    </div>
  )
}